<template>
  <div class="customer-railsbank-form-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-office-building"></i>Edit customer</span>
        
      </div>
      <el-form
      v-if="customerForm"
        :model="customerForm"
        id="customerForm"
        ref="customerForm"
        label-width="150px"
        size="small"
        :rules="customerFormRules"
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >
        <el-alert v-if="errMsg" :title="errMsg" type="error" show-icon>
        </el-alert>
        <el-row :gutter="50">
     
          <el-col>
            <el-divider content-position="left">Status</el-divider>

            <el-col :xs="24" :sm="24" :md="12" :lg="12" style="padding:0">
            <el-form-item label="Status">
              <el-select
                v-model="customerForm.status"
                placeholder="please select status"
              >
                <el-option label="Active" value="active"></el-option>
                <el-option label="Disable" value="disable"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-checkbox v-model="customerForm.kyc.company.riskBusiness">Risk Business</el-checkbox>
            </el-form-item>
            </el-col>
          </el-col>
          <el-col  :xs="24" :sm="24" :md="12" :lg="12">

            <el-divider content-position="left">KYB Company</el-divider>
            <el-form-item prop="name" label="Company Name">
              <el-input v-model="customerForm.kyc.company.name"></el-input>
            </el-form-item>

            <el-form-item prop="tradingName" label="Trading Name">
              <el-input v-model="customerForm.kyc.company.tradingName"></el-input>
            </el-form-item>

            <el-form-item
              prop="typeOfBusiness"
              label="Type Of Business"
            >
              <el-input v-model="customerForm.kyc.company.typeOfBusiness"></el-input>
            </el-form-item>

            <el-form-item
              prop="natureofbusiness"
              label="Nature of Business"
            >
              <!-- <el-input v-model="customerForm.kyc.company.natureofbusiness"></el-input> -->
              <el-autocomplete
                class="inline-input"
                v-model="customerForm.kyc.company.natureofbusiness"
                :fetch-suggestions="querySearchNatureofbusiness"
              ></el-autocomplete>
            </el-form-item>

            <el-form-item
              prop="regulateFinancial"
              label="Regulate Financial"
            >
              <el-switch
                v-model="customerForm.kyc.company.regulateFinancial"
              ></el-switch>
            </el-form-item>

            <el-form-item
              prop="registrationNumber"
              label="Registration Number"
            >
              <el-input
                v-model="customerForm.kyc.company.registrationNumber"
              ></el-input>
            </el-form-item>

            <el-form-item prop="approvedate" label="Approve Date">
              <el-date-picker
                v-model="customerForm.kyc.company.approvedate"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item prop="telephone" label="Telephone">
              <el-input
                prefix-icon="el-icon-phone"
                v-model="customerForm.kyc.company.telephone"
              ></el-input>
            </el-form-item>

            <el-form-item prop="webSite" label="Website">
              <el-input
                prefix-icon="el-icon-link"
                v-model="customerForm.kyc.company.webSite"
              ></el-input>
            </el-form-item>

            <el-form-item prop="email" label="Email Contact">
              <el-input
                prefix-icon="el-icon-message"
                v-model="customerForm.kyc.company.email"
              ></el-input>
            </el-form-item>

            <el-form-item prop="addressnumber" label="Address number">
              <el-input v-model="customerForm.kyc.company.addressnumber"></el-input>
            </el-form-item>

            <el-form-item prop="street" label="Street">
              <el-input v-model="customerForm.kyc.company.street"></el-input>
            </el-form-item>

            <el-form-item prop="city" label="City">
              <el-input v-model="customerForm.kyc.company.city"></el-input>
            </el-form-item>

            <el-form-item prop="zipcode" label="Zipcode">
              <el-input v-model="customerForm.kyc.company.zipcode"></el-input>
            </el-form-item>

            <el-form-item prop="refinement" label="Refinement">
              <el-input v-model="customerForm.kyc.company.refinement"></el-input>
            </el-form-item>

            <el-form-item prop="region" label="Region">
              <el-input v-model="customerForm.kyc.company.region"></el-input>
            </el-form-item>

            <el-form-item prop="countrycode" label="Country code">
              <el-autocomplete
                class="inline-input"
                v-model="customerForm.kyc.company.countrycode"
                :fetch-suggestions="querySearchCountrycode"
                @select="selectCompanyCountrycode"
                :maxlength="2"
              >
                <template slot-scope="{ item }">
                  <div>{{ item.country_code }} - {{ item.country_name }}</div>
                </template></el-autocomplete
              >
            </el-form-item>

          </el-col>
          <el-col  :xs="24" :sm="24" :md="12" :lg="12">

            <el-divider content-position="left">KYB Director</el-divider>

            <el-form-item prop="director_name" label="Director Name">
              <el-input v-model="customerForm.kyc.director.name"></el-input>
            </el-form-item>

            <el-form-item prop="director_dateOfBirth" label="Date Of Birth">
              <el-date-picker
                v-model="customerForm.kyc.director.dateOfBirth"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item prop="director_position" label="Position">
              <el-input v-model="customerForm.kyc.director.position"></el-input>
            </el-form-item>

            <el-form-item prop="director_telephone" label="Telephone">
              <el-input
                prefix-icon="el-icon-phone"
                v-model="customerForm.kyc.director.telephone"
              ></el-input>
            </el-form-item>

            <el-form-item prop="director_email" label="Email">
              <el-input
                prefix-icon="el-icon-message"
                v-model="customerForm.kyc.director.email"
              ></el-input>
            </el-form-item>

            <el-form-item prop="director_nationality" label="Nationality">
              <!-- <el-input v-model="customerForm.kyc.director.nationality"></el-input> -->
              <el-autocomplete
                prefix-icon="el-icon-s-flag"
                class="inline-input"
                v-model="customerForm.kyc.director.nationality"
                :fetch-suggestions="querySearchNationality"
              ></el-autocomplete>
            </el-form-item>

            <el-form-item prop="director_identifyType" label="Identify Type">
              <!-- <el-input v-model="customerForm.kyc.director.identifyType"></el-input> -->
              <el-select v-model="customerForm.kyc.director.identifyType">
                <el-option label="Passport" value="passport"></el-option>
                <el-option
                  label="Driving Licence"
                  value="driving-licence"
                ></el-option>
                <el-option
                  label="Identity Card"
                  value="identity-card"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              prop="director_identifyNumber"
              label="Identify Number"
            >
              <el-input
                v-model="customerForm.kyc.director.identifyNumber"
              ></el-input>
            </el-form-item>

            <el-form-item
              prop="director_identifyExpire"
              label="Identify Expire"
            >
              <el-date-picker
                v-model="customerForm.kyc.director.identifyExpire"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item prop="director_addressnumber" label="Address number">
              <el-input v-model="customerForm.kyc.director.addressnumber"></el-input>
            </el-form-item>

            <el-form-item prop="director_street" label="Street">
              <el-input v-model="customerForm.kyc.director.street"></el-input>
            </el-form-item>

            <el-form-item prop="director_city" label="City">
              <el-input v-model="customerForm.kyc.director.city"></el-input>
            </el-form-item>

            <el-form-item prop="director_zipcode" label="Zipcode">
              <el-input v-model="customerForm.kyc.director.zipcode"></el-input>
            </el-form-item>

            <el-form-item prop="director_refinement" label="Refinement">
              <el-input v-model="customerForm.kyc.director.refinement"></el-input>
            </el-form-item>

            <el-form-item prop="director_region" label="Region">
              <el-input v-model="customerForm.kyc.director.region"></el-input>
            </el-form-item>
            
            <el-form-item
              prop="residentCountry"
              label="Resident Country"
            >
              <el-autocomplete
                prefix-icon="el-icon-s-flag"
                class="inline-input"
                v-model="customerForm.kyc.director.residentCountry"
                :fetch-suggestions="querySearchResidentCountry"
                @select="selectDirectorResidentCountrycode"
                :maxlength="2"
              >
                <template slot-scope="{ item }">
                  <div>{{ item.country_code }} - {{ item.country_name }}</div>
                </template>
              </el-autocomplete>
            </el-form-item>

            <el-form-item prop="director_countrycode" label="Country code">
              <el-autocomplete
                class="inline-input"
                v-model="customerForm.kyc.director.countrycode"
                :fetch-suggestions="querySearchCountrycode"
                @select="selectDirectorCountrycode"
                :maxlength="2"
              >
                <template slot-scope="{ item }">
                  <div>{{ item.country_code }} - {{ item.country_name }}</div>
                </template></el-autocomplete
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="footer text-center">
        <el-button type="primary" :loading="submiting" @click="submitCustomer()"
          >Submit</el-button
        >
        <el-button @click="cancelForm">Cancel</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getUtility, updateCustomer } from "@/api/customer";
export default {
  props: {
    formData: Object
  },
  computed: {
    ...mapGetters(["user_project"]),
    device() {
      return this.$store.state.app.device;
    },
  },
  data() {
    return {
      submiting: false,
      dialogShow: false,
      errMsg: "",
      utility: {},
      customerForm: null,
      customerFormRules: {}//model.rules,
    };
  },
  methods: {
    getUtility() {
      getUtility().then(({ result, data }) => {
        if (result) {
          this.utility = data;
        }
      });
    },
    cancelForm() {
      if(this.$route.query.ref && this.$route.query.ref == 'customer'){
        this.$router.push(`/project/${this.user_project}?tab=customer`);
      }else if( this.$route.query.ref && this.$route.query.ref == 'info'){
        this.$router.push(`/customer/view/${this.user_project}/${this.customerForm.enduser_id}`);
      }else{
        this.$router.push('/customer')
      }
      
    },

    getFormData() {
      let formData = JSON.parse(JSON.stringify(this.customerForm));
      delete formData.riskBusiness
      return formData;
    },

    updateCustomer() {
      let formData = this.getFormData();
      this.submiting = true;
      this.errMsg = "";
      updateCustomer(formData.enduser_id, formData).then(
        ({ result, message }) => {
          this.submiting = false;
          if (result) {
            this.$notify({
              title: "Success",
              message: `Update Customer successfully`,
              type: "success",
              duration: 2000
            });
            this.cancelForm()
            this.$emit("on-submited", true);
          } else {
            this.errMsg =
              typeof message === "string" ? message : "Update Customer Error";
          }
        }
      );
    },
    submitCustomer() {
     //this.$emit("on-submited", true);
        this.$refs.customerForm.validate((valid) => {
          if (valid) {
            this.updateCustomer();
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      
    },
    resetForm() {
      if (this.$refs.customerForm) this.$refs.customerForm.resetFields();
    },
    querySearchCountrycode(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "country_code"))
        : data;
      // const lists = []
      // results.forEach((item)=>{
      //   lists.push({value : item.country_code})
      // })
      cb(results);
    },
    querySearchResidentCountry(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "country_code"))
        : data;
      // const lists = []
      // results.forEach((item)=>{
      //   lists.push({value : item.country_name})
      // })
      cb(results);
    },
    querySearchNationality(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "nationality"))
        : data;
      const lists = [];
      results.forEach((item) => {
        lists.push({ value: item.nationality });
      });
      cb(lists);
    },
    querySearchNatureofbusiness(queryString, cb) {
      var data = this.utility.natureofbusiness;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "name"))
        : data;
      const lists = [];
      results.forEach((item) => {
        lists.push({ value: item.name });
      });
      cb(lists);
    },

    selectCompanyCountrycode(item) {
      this.customerForm.kyc.company.countrycode = item.country_code;
    },
    selectDirectorCountrycode(item) {
      this.customerForm.kyc.director.countrycode = item.country_code;
    },

    selectDirectorResidentCountrycode(item){
      this.customerForm.kyc.director.residentCountry = item.country_code;
    },
  
    createFilter(queryString, key) {
      return (item) => {
        return item[key].toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },

  },
  mounted() {
    this.getUtility();
    this.customerForm = this.formData;
  },
};
</script>

<style lang="scss">
.customer-railsbank-form-container {
  .el-form-item--small.el-form-item {
    margin-bottom: 16px;
  }
  .item__label {
    line-height: 30px;
    font-weight: bold;
  }

  .el-form-item__label {
    font-size: 12px;
  }

  .el-divider__text {
    font-weight: bold;
    font-size: 14px;
    color: #424242;
  }

  .footer{
    border-top: 1px solid #ebeef5;
    padding-top: 20px;
    margin-top: 20px;
    margin-left: -20px;
    margin-right: -20px;
  }

}
</style>